"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushDatalayerInformation = void 0;
var react_1 = __importStar(require("react"));
var useCookieConsent_1 = __importDefault(require("@empiriecom/module-components/hooks/useCookieConsent"));
// eslint-disable-next-line import/no-cycle
var __1 = require("..");
var pushDatalayerInformation = function (externalApiKey) {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
        event: 'renderTrustedShops',
        eventValue: {
            trustedShopsApiKey: externalApiKey,
        },
    });
};
exports.pushDatalayerInformation = pushDatalayerInformation;
var TrustedShops = function (_a) {
    var externalApiKey = _a.externalApiKey;
    // TODO which category? C0004 is just guessed
    var isTrustedShopsAllowed = useCookieConsent_1.default('C0005');
    // the global _tsconfig must be set here because the GTM has no access to global variables
    // eslint-disable-next-line no-underscore-dangle
    global._tsconfig = {
        yOffset: '0' /* offset from page bottom */,
        variant: 'custom_reviews' /* default, reviews, custom, custom_reviews */,
        customElementId: __1.Types.TrustedShops /* required for variants custom and custom_reviews */,
        trustcardDirection: '' /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */,
        customBadgeWidth: '50' /* for custom variants: 40 - 90 (in pixels) */,
        customBadgeHeight: '64' /* for custom variants: 40 - 90 (in pixels) */,
        disableResponsive: 'true' /* deactivate responsive behaviour */,
        disableTrustbadge: 'false' /* deactivate trustbadge */,
    };
    react_1.useEffect(function () { return (isTrustedShopsAllowed && exports.pushDatalayerInformation(externalApiKey)) || undefined; }, [isTrustedShopsAllowed]);
    return react_1.default.createElement("div", { "data-testid": __1.CustomScriptTestIds.TrustedShopsScript, id: __1.Types.TrustedShops });
};
exports.default = TrustedShops;
//# sourceMappingURL=TrustedShops.js.map